export * from './authentication/authentication.service';
export * from './boleto/boleto.service';
export * from './cliente/cliente.service';
export * from './contrato/contrato.service';
export * from './ibge/ibge.service';
export * from './inventario/inventario.service';
export * from './defeito/defeito.service';
export * from './equipamento/equipamento.service';
export * from './fatura/fatura.service';
export * from './grupo-economico/grupo-economico.service';
export * from './login/login.service';
export * from './os/os.service';
export * from './perfil/perfil.service';
export * from './senha/senha.service';
export * from './site/site.service';
export * from './tecnico/tecnico.service';
export * from './toast/toast.service';
export * from './usuario/usuario.service';
